import { defineMessages } from 'react-intl';

/**
 * Descriptions for third-party connectors displayed in the discovery page.
 * These are keyed by the connector `source` identifier from the API.
 */
export const connectorDescriptionMessages: {
	adobe_sign: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adobe_xd: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aha: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	airtable: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	amplitude: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	asana: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'atlassian-web-crawler': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aws: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aws_s3: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	azure: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	azure_devops: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	box: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	canva: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clickup: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'confluence-dc': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	databricks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datadog: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	docker: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	docusign: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dovetail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dropbox: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	entra: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	figma: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	freshservice: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gcp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gitbook: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	github: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gitlab: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gmail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	google_calendar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	google_drive: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hubspot: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jenkins: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira_dc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	launchdarkly: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loom: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lucid: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	microsoft: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	microsoft_onedrive: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	microsoft_outlook_calendar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	microsoft_outlook_mail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	microsoft_power_bi: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	microsoft_sharepoint: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teams: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	miro: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	monday: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mural: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pagerduty: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pipedrive: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	salesforce: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentry: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	servicenow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	slack: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	smartsheet: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	splunk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stripe: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	todoist: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webex: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	zendesk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	zeplin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	adobe_sign: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.adobe-sign.v1',
		defaultMessage: 'Sign and send documents electronically',
		description: 'Short description for the Adobe Sign connector',
	},
	adobe_xd: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.adobe-xd.v1',
		defaultMessage: 'Design and prototype user experiences',
		description: 'Short description for the Adobe XD connector',
	},
	aha: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.aha.v1',
		defaultMessage: 'Build product roadmaps and strategy',
		description: 'Short description for the Aha connector',
	},
	airtable: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.airtable.v1',
		defaultMessage: 'Manage tasks, projects, and data in one place',
		description: 'Short description for the Airtable connector',
	},
	amplitude: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.amplitude.v1',
		defaultMessage: 'Analyze product usage and behavior',
		description: 'Short description for the Amplitude connector',
	},
	asana: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.asana.v1',
		defaultMessage: 'Track projects and assign tasks',
		description: 'Short description for the Asana connector',
	},
	'atlassian-web-crawler': {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.atlassian-web-crawler.v1',
		defaultMessage: 'Search for content across your websites',
		description: 'Short description for the Atlassian Web Crawler connector',
	},
	aws: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.aws.v1',
		defaultMessage: 'Deploy and manage cloud infrastructure',
		description: 'Short description for the AWS connector',
	},
	aws_s3: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.aws-s3.v1',
		defaultMessage: 'Store and retrieve files in the cloud',
		description: 'Short description for the AWS S3 connector',
	},
	azure: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.azure.v1',
		defaultMessage: 'Build and host cloud applications',
		description: 'Short description for the Azure connector',
	},
	azure_devops: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.azure-devops.v1',
		defaultMessage: 'Automate builds and deployments',
		description: 'Short description for the Azure DevOps connector',
	},
	box: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.box.v1',
		defaultMessage: 'Search files alongside company knowledge',
		description: 'Short description for the Box connector',
	},
	canva: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.canva.v1',
		defaultMessage: 'Create graphics and presentations',
		description: 'Short description for the Canva connector',
	},
	clickup: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.clickup.v1',
		defaultMessage: 'Manage tasks, docs, and goals',
		description: 'Short description for the ClickUp connector',
	},
	'confluence-dc': {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.confluence-dc.v1',
		defaultMessage: 'Create and organize team knowledge in one place',
		description: 'Short description for the Confluence Data Center connector',
	},
	confluent: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.confluent.v1',
		defaultMessage: 'Monitor streaming data and topics',
		description: 'Short description for the Confluent connector',
	},
	databricks: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.databricks.v1',
		defaultMessage: 'Explore notebooks and datasets',
		description: 'Short description for the Databricks connector',
	},
	datadog: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.datadog.v1',
		defaultMessage: 'Review metrics and monitoring data',
		description: 'Short description for the Datadog connector',
	},
	docker: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.docker.v1',
		defaultMessage: 'Locate and deploy containerized apps',
		description: 'Short description for the Docker connector',
	},
	docusign: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.docusign.v1',
		defaultMessage: 'Track digital agreements and signatures',
		description: 'Short description for the Docusign connector',
	},
	dovetail: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.dovetail.v1',
		defaultMessage: 'Organize and analyze user research',
		description: 'Short description for the Dovetail connector',
	},
	dropbox: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.dropbox.v1',
		defaultMessage: 'Sync and share files across devices',
		description: 'Short description for the Dropbox connector',
	},
	entra: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.entra.v1',
		defaultMessage: 'Manage identities and access control',
		description: 'Short description for the Microsoft Entra connector',
	},
	figma: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.figma.v1',
		defaultMessage: 'Gain fast access to Design and Figjam files',
		description: 'Short description for the Figma connector',
	},
	freshservice: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.freshservice.v1',
		defaultMessage: 'Manage IT tickets and requests',
		description: 'Short description for the Freshservice connector',
	},
	gcp: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.gcp.v1',
		defaultMessage: "Build apps on Google's cloud",
		description: 'Short description for the Google Cloud Platform connector',
	},
	gitbook: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.gitbook.v1',
		defaultMessage: 'Write and publish documentation',
		description: 'Short description for the GitBook connector',
	},
	github: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.github.v1',
		defaultMessage: 'Host code and collaborate on projects',
		description: 'Short description for the GitHub connector',
	},
	gitlab: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.gitlab.v1',
		defaultMessage: 'Build, test, and deploy code',
		description: 'Short description for the GitLab connector',
	},
	gmail: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.gmail.v1',
		defaultMessage: 'Make content from your emails searchable',
		description: 'Short description for the Gmail connector',
	},
	google_calendar: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.google-calendar.v1',
		defaultMessage: 'Easily find details of events and meetings',
		description: 'Short description for the Google Calendar connector',
	},
	google_drive: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.google-drive.v1',
		defaultMessage: 'Get insights from docs, sheets, slides and more',
		description: 'Short description for the Google Drive connector',
	},
	hubspot: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.hubspot.v1',
		defaultMessage: "Find your team's deals and marketing campaigns",
		description: 'Short description for the HubSpot connector',
	},
	jenkins: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.jenkins.v1',
		defaultMessage: "Access your team's current builds",
		description: 'Short description for the Jenkins connector',
	},
	jira_dc: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.jira-dc.v1',
		defaultMessage: 'Locate work by searching all issues and projects',
		description: 'Short description for the Jira Data Center connector',
	},
	launchdarkly: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.launchdarkly.v1',
		defaultMessage: 'Instantly surface feature releases and flags',
		description: 'Short description for the LaunchDarkly connector',
	},
	loom: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.loom.v1',
		defaultMessage: 'Find the right moment from videos and transcripts',
		description: 'Short description for the Loom connector',
	},
	lucid: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.lucid.v1',
		defaultMessage: 'Make diagrams and flowcharts easily available',
		description: 'Short description for the Lucid connector',
	},
	microsoft: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.microsoft.v1',
		defaultMessage: 'Access Microsoft 365 apps and data',
		description: 'Short description for the Microsoft connector',
	},
	microsoft_onedrive: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.microsoft-onedrive.v1',
		defaultMessage: 'Sync all files from OneDrive across devices',
		description: 'Short description for the Microsoft OneDrive connector',
	},
	microsoft_outlook_calendar: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.microsoft-outlook-calendar.v1',
		defaultMessage: 'Locate details of key events and meetings',
		description: 'Short description for the Microsoft Outlook Calendar connector',
	},
	microsoft_outlook_mail: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.microsoft-outlook-mail.v1',
		defaultMessage: 'Search for information from all your emails',
		description: 'Short description for the Microsoft Outlook Mail connector',
	},
	microsoft_power_bi: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.microsoft-power-bi.v1',
		defaultMessage: 'Understand your reports and dashboards',
		description: 'Short description for the Microsoft Power BI connector',
	},
	microsoft_sharepoint: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.microsoft-sharepoint.v1',
		defaultMessage: 'Get answers from your docs, slides, and more',
		description: 'Short description for the Microsoft SharePoint connector',
	},
	teams: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.microsoft-teams.v1',
		defaultMessage: 'Surface context from chats, meetings, and transcripts',
		description: 'Short description for the Microsoft Teams connector',
	},
	miro: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.miro.v1',
		defaultMessage: 'Visualize team knowledge from digital whiteboards',
		description: 'Short description for the Miro connector',
	},
	monday: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.monday.v1',
		defaultMessage: 'Centralize knowledge from boards and workflows',
		description: 'Short description for the Monday connector',
	},
	mural: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.mural.v1',
		defaultMessage: 'Search designs and capture ideas',
		description: 'Short description for the Mural connector',
	},
	notion: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.notion.v1',
		defaultMessage: 'Search notes, docs, and wikis from your entire team',
		description: 'Short description for the Notion connector',
	},
	pagerduty: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.pagerduty.v1',
		defaultMessage: 'See the most recent incidents and alerts',
		description: 'Short description for the PagerDuty connector',
	},
	pipedrive: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.pipedrive.v1',
		defaultMessage: "Quickly access your team's deals and manage sales",
		description: 'Short description for the Pipedrive connector',
	},
	salesforce: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.salesforce.v1',
		defaultMessage: 'Manage customers and sales data',
		description: 'Short description for the Salesforce connector',
	},
	sentry: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.sentry.v1',
		defaultMessage: 'Track and fix application errors',
		description: 'Short description for the Sentry connector',
	},
	servicenow: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.servicenow.v1',
		defaultMessage: 'Effortlessly search for IT services and requests',
		description: 'Short description for the ServiceNow connector',
	},
	slack: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.slack.v1',
		defaultMessage: 'Search chats and channels and find key information',
		description: 'Short description for the Slack connector',
	},
	smartsheet: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.smartsheet.v1',
		defaultMessage: 'Bring information together from all your spreadsheets',
		description: 'Short description for the Smartsheet connector',
	},
	splunk: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.splunk.v1',
		defaultMessage: 'Search and analyze machine data',
		description: 'Short description for the Splunk connector',
	},
	stripe: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.stripe.v1',
		defaultMessage: 'Process payments and subscriptions',
		description: 'Short description for the Stripe connector',
	},
	todoist: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.todoist.v1',
		defaultMessage: 'Create and organize task lists',
		description: 'Short description for the Todoist connector',
	},
	webex: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.webex.v1',
		defaultMessage: 'Host video meetings and calls',
		description: 'Short description for the Webex connector',
	},
	zendesk: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.zendesk.v1',
		defaultMessage: 'Jump into support and manage customer tickets',
		description: 'Short description for the Zendesk connector',
	},
	zeplin: {
		id: 'ai-mate.rovo-settings-modal.discovery.connector-description.zeplin.v1',
		defaultMessage: 'Access all your projects and designs effortlessly',
		description: 'Short description for the Zeplin connector',
	},
});
